export default "__VITE_ASSET___W9MPA5Q__"